
import { CloseIcon } from '@chakra-ui/icons'
import { Button, IconButton, Text, VStack } from '@chakra-ui/react'
import { themeColors } from 'theme'

import { CheckmarkIcon, ExclamationIcon, InfoIcon } from 'components/SVGS'

import { PrimaryProps } from '../types'

const { text: { bgInfoColorText }, icon: { closeModalIconColor, infoModalIconColor } } = themeColors

export const PrimaryVariant: React.FC<PrimaryProps> = ({
  closeAcceptPress,
  closeGoBackPress,
  title,
  message,
  messageAlignmentLeft = false,
  customFillIcon = infoModalIconColor,
  primaryButton = false,
  primaryTextButton = 'Entendido',
  primaryButtonProps,
  secondaryButton = false,
  secondaryTextButton,
  secondaryButtonProps,
  iconType = 'info',
  showClose = false,
}) => {
  return (
    <VStack
      w={'full'}
      h={'full'}
      alignItems={'flex-start'}
      justifyContent={'flex-start'}
      spacing={{ base: 8, md: 4 }}
      p={{ base: 1, md: 2 }}>
      <VStack hidden={showClose} w={'full'} justifyContent={'center'} alignItems={'flex-end'}>
        <IconButton onClick={closeGoBackPress}
          aria-label='icon'
          bg={closeModalIconColor}
          variant={'solid'}
          rounded={'full'}
          h={{ base: 8, md: 10 }}
          minW={{ base: 8, md: 10 }}
          fontSize={{ base: 'xs', md: 'md' }}
          icon={<CloseIcon />}
        />
      </VStack>
      <VStack w={'full'} justifyContent={'center'} alignItems={'center'} spacing={4}>
        {iconType === 'info'
          ? <InfoIcon size={{ base: 12, md: 24 }} fill={customFillIcon} />
          : iconType === 'success'
            ? <CheckmarkIcon size={{ base: 12, md: 24 }} />
            : <ExclamationIcon size={{ base: 12, md: 24 }} />
        }
        {(title || message)
          && <VStack>
            {title &&
              <Text variant={{ base: 'SM_SB', md: 'LG_SB' }} textAlign={'center'}>{title}</Text>
            }
            {message &&
              <Text
                color={bgInfoColorText}
                textAlign={messageAlignmentLeft ? 'left' : 'center'}
                variant={{ base: 'XS', md: 'MD' }}>
                {message}
              </Text>
            }
          </VStack>
        }
        {primaryButton &&
          <Button onClick={closeAcceptPress} w={'full'} variant={'primary'} {...primaryButtonProps}>
            {primaryTextButton ??= 'Entendido'}
          </Button>
        }
        {secondaryButton &&
          <Button onClick={closeGoBackPress} w={'full'} variant={'secondary'} {...secondaryButtonProps}>
            {secondaryTextButton ??= 'Cancelar'}
          </Button>
        }
      </VStack>
    </VStack>
  )
}
